import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { SignInListCard } from '../SignInListCard';
import enterpriseImage from '../assets/UCS_Sign_In_Platinum.png';

const COPY = defineMessages({
  HEADLINE: {
    id: 'EnterpriseSignInListCard.title',
    defaultMessage: 'Work smarter and faster as a team',
    description: '[Type: Header][Vis.: low] -  EnterpriseSignInListCard title',
  },
  MESSAGE_ONE: {
    id: 'EnterpriseSignInListCard.messagesOne',
    defaultMessage: 'Powerful collaboration features',
    description:
      '[Type: Paragraph][Vis.: low] - EnterpriseSignInListCard message one',
  },
  MESSAGE_TWO: {
    id: 'EnterpriseSignInListCard.messagesTwo',
    defaultMessage: 'User and data management',
    description:
      '[Type: Paragraph][Vis.: low] - EnterpriseSignInListCard message two',
  },
  MESSAGE_THREE: {
    id: 'EnterpriseSignInListCard.messagesThree',
    defaultMessage: 'Consolidated billing',
    description:
      '[Type: Paragraph][Vis.: low] - EnterpriseSignInListCard message three',
  },
});

export const EnterpriseSignInListCard: React.FC = () => {
  return (
    <SignInListCard
      headline={t(COPY.HEADLINE)}
      messages={[
        t(COPY.MESSAGE_ONE),
        t(COPY.MESSAGE_TWO),
        t(COPY.MESSAGE_THREE),
      ]}
      image={() => <img src={enterpriseImage} alt="" aria-hidden="true" />}
    />
  );
};

export default EnterpriseSignInListCard;
